import {
  SEARCH_ROOM_HISTORY_REQUEST,
  SEARCH_ROOM_HISTORY_SUCCESS,
  SEARCH_ROOM_HISTORY_FAILURE,
  FETCH_ROOM_HISTORY_BY_ID_REQUEST,
  FETCH_ROOM_HISTORY_BY_ID_SUCCESS,
  FETCH_ROOM_HISTORY_BY_ID_FAILURE,
  ADD_ROOM_HISTORY_RSV_REQUEST,
  ADD_ROOM_HISTORY_RSV_SUCCESS,
  ADD_ROOM_HISTORY_RSV_FAILURE,
} from "../action/roomHistoryActions";

// State awal
const initialState = {
  data: [],
  byId: [], // Menyimpan data riwayat kamar
  loading: false,
  error: null,
};

// Reducer untuk mengelola state riwayat kamar
const roomHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_ROOM_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SEARCH_ROOM_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload, // Memperbarui data dengan hasil pencarian
      };
    case SEARCH_ROOM_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload, // Menyimpan pesan error
      };
    case FETCH_ROOM_HISTORY_BY_ID_REQUEST:
      return {
        ...state,
        byId: {},
        detailRequestId: action.requestId,
        loading: true,
        error: null,
      };
    case FETCH_ROOM_HISTORY_BY_ID_SUCCESS:
      if (action.requestId !== state.detailRequestId) return state;
      return {
        ...state,
        loading: false,
        byId: action.payload, // Memperbarui data dengan hasil pencarian
      };
    case FETCH_ROOM_HISTORY_BY_ID_FAILURE:
      if (action.requestId !== state.detailRequestId) return state;
      return {
        ...state,
        loading: false,
        error: action.payload, // Menyimpan pesan error
      };
    case ADD_ROOM_HISTORY_RSV_REQUEST:
      return {
        ...state,
        loading: true, // Menandakan bahwa data sedang diproses
        error: null,
      };
    case ADD_ROOM_HISTORY_RSV_SUCCESS:
      return {
        ...state,
        loading: false,
        data: Array.isArray(action.payload)
          ? [...state.data, ...action.payload]
          : [...state.data], // Handle case where payload might not be an array
      };
    case ADD_ROOM_HISTORY_RSV_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload, // Menyimpan pesan error untuk tindakan ini
      };
    default:
      return state;
  }
};

export default roomHistoryReducer;
